import React, { useEffect, useState,useContext } from 'react';
import './ConfirmationPopup.css';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';
import MenuItem from '@mui/material/MenuItem';
import Edit from '@mui/icons-material/Edit';
import Warning from '@mui/icons-material/Warning';
import mebileverification1 from '../../assets/mebileverification1.svg';
import mobile_verified_successfully from '../../assets/mobile_verified_successfully.svg';
import awaiting_parental_consent from '../../assets/awaiting_parental_consent.svg';
import account_unlocked from '../../assets/account_unlocked.svg';

import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import OTPTime from '../../assets/otp_time_exp.svg';
import {  API, graphqlOperation } from 'aws-amplify';
import * as queries from '../../graphql/queries';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import validator from 'validator';
import Dialog from '@mui/material/Dialog';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import ChevronRight from '@mui/icons-material/ChevronRight';
import Sync from '@mui/icons-material/Sync';
import { updateUserMaster } from "../../graphql/mutations";
import FormHelperText from '@mui/material/FormHelperText';
import { useDispatch, useSelector } from 'react-redux';
import { userActions } from '../actions/userActions';
import ParentalDecline from '../../assets/parental_decline.png';
import { UserContext } from '../../App';
import { getUseraccess } from "../auth/util/util";
import fetchItemsNextToken from '../../graphql/fetchItemsNextToken';
import { DialogContent } from '@mui/material';
import fetchSearchItemsNextToken from '../../graphql/fetchSearchItemsNextToken';

function ConfirmationPopup(props) {
  const [openTost, setOpenTost] = React.useState(false);
  const [Tost_msg, setTost_msg] = useState('This is a success message!');
  const [secondsISmobile, setmobileSeconds] = useState(false);
  const [seconds_mobile, setSeconds_mobile] = useState(null);
  const [mobile, setMobile] = useState('');
  const [oldmobile, setOldmobile] = useState('');
  const [parentmobile, setParentmobile] = useState('');
  const [countryCode, setCountryCode] = useState('');
  const [parentcountryCode, setParentcountryCode] = useState('');
  const [showotp, setShowotp] = useState(false);
  const [firstscreen, setFirstscreen] = useState(true);
  const [secondscreen, setSecondscreen] = useState(false);
  const [fourthscreen, setFourthscreen] = useState(false);
  const [fifthscreen, setFifthscreen] = useState(false);
  const [sixthscreen, setSixthscreen] = useState(false);
  const [seventhscreen, setSeventhscreen] = useState(false);
  const [eightscreen, setEightscreen] = useState(false);
  const [parentrequestsent, setParentrequestsent] = useState(false);
  const [nextclick,setNextclick]=useState(false);
  const [otpError, setOtpError] = useState('');
  const [mobiledis, setMobiledis] = useState(true);
  const [userEmail, setUserEmail] = useState(props.userEmail);
  const [nameError, setNameError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [mobileError, setMobileError] = useState('');
  const [gardianCheck, setGardianCheck] = useState(true);
  const [gardianCheckError, setGardianCheckError] = useState('');
  const [email, setEmail] = useState('');
  const [parentemail, setParentEmail] = useState('');
  const [parentname, setParentname] = useState('');
  const [mobileverification, setMobileverification] = useState(false);
  const [parentverification, setParentverification] = useState(false);
  const [settingmessage, setSettingmessage] = useState('');
  const [showparentalconsent, setShowparentalconsent] = useState(true);
  const [showskipbutton, setShowskipbutton] = useState(true);
  const [Showlogoutbutton, setShowlogoutbutton] = useState(false);
  const [steps, setSteps] = useState(['Mobile verification', 'Parental Consent']);
  const [parentapprovestatus, setParentapprovestatus] = useState(0);
  const dispatch = useDispatch();
  const authenticationState = useSelector(state => state.authenticationState);
  const alertState = useSelector(state => state.alertState);
  const alertMsg = useSelector(state => state.alertState);
  const [parrentatatus, setParentstatus] = useState(0);
  const [popupTopMsg,setPopupTopMsg]=useState('');
  const [popupSecondTopMsg,setPopupSecondTopMsg]=useState('');
  const [showPendingicon,setShowPendingicon]=useState(false);
  const [countryData,setCountryData] = useState([]);
  //   SKIP steps START HERE
  const [openVerification, setOpenVerification] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const navigate = useNavigate();
  const userAccessRoleContext = useContext(UserContext);
  useEffect( () => {
     const initialFun = async() =>{

    // fetch(process.env.PUBLIC_URL+`/countries-states-cities.json`)
    //   .then(response => response.json())
    //   .then(data => {
    //     console.log(data);
    //     setCountryData(data)
    //     setCountryCode(data[102].phone_code);//SET DEFAULT COUNTRY CODE FOR MOBILE
    //     setParentcountryCode(data[102].phone_code);//SET DEFAULT COUNTRY CODE FOR PARENT MOBILE
    //   })
    const listCountries=await fetchItemsNextToken({query:queries.listCountries,variables:{ limit: 10000 }});
    if(listCountries.length>0)
    {
      setCountryData(listCountries);
      setCountryCode(listCountries[102].phone_code);//SET DEFAULT COUNTRY CODE FOR MOBILE
      setParentcountryCode(listCountries[102].phone_code);//SET DEFAULT COUNTRY CODE FOR PARENT MOBILE
    }


    
   

    setUserEmail(localStorage.getItem('email'));//SET STATE FOR EMAILID
    
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));//GET PROFILE userDetails FROM localstorage
    
    let phone_number = userDetails?.phone_number;
    phone_number = userDetails?.phone_number.substring(3);


    let userDetailsID = localStorage.getItem('userDetailsID');//GET PROFILE userDetailsID FROM localstorage
    if(userDetailsID)
    {

    let cardItemDataQuery=await fetchSearchItemsNextToken({query:queries.searchInterestUsers,variables:{filter: {userProfileDetailsInterestsId: {eq: userDetailsID}},limit:500}})
    let getInterestsData=cardItemDataQuery.filter(item => item._deleted !== true).sort((a, b) => b.createdAt.localeCompare(a.createdAt));
    const userID = localStorage.getItem('userID'); //GET MASTER userID FROM localstorage 
    //const userMasterData = await API.graphql(graphqlOperation(queries.listUserMasters, { filter: { id: { eq: userID } }, limit: 10000 }));
    const userMasterData=await fetchItemsNextToken({query:queries.listUserMasters,variables:{ filter: { id: { eq: userID } }, limit: 10000 }})
    const items = userMasterData;
    const newMasterData = items.filter(item => item._deleted !== true);
   
    let userData = await API.graphql(graphqlOperation(queries.getUserProfileDetails, { id: userDetailsID }));
    let newData = userData.data.getUserProfileDetails;
    setParentEmail(newData.parent_email);
  

    var userisMobileVerified = (newData.isMobileVerified == null || newData.isMobileVerified == false) ? 0 : 1;
    var userisParentVerified = (newData.isParentVerified == null || newData.isParentVerified == false) ? 0 : 1;
    var userisSelfEmailVerified = (newData.isSelfEmailVerified == null || newData.isSelfEmailVerified == false) ? 0 : 1;
    var userisDisabled = (newData.disabled == 1) ? 1 : 0;
    var userisMinor = (newData.userID.isParent == true) ? 1 : 0;

    const userAccessData = await API.graphql(graphqlOperation(queries.listUserAccessRoles, { limit: 100000 }));
    const roleitems = userAccessData.data.listUserAccessRoles.items.filter(item => item.priority == 1);
    let userAccess = roleitems.find(item => item.isMobileVerified == userisMobileVerified && item.isParentVerified == userisParentVerified && item.isSelfEmailVerified == userisSelfEmailVerified && item.isDisabled == userisDisabled && item.isMinor == userisMinor);

    if(userAccess.enableParentalVerification==0 && userAccess.enableMobileVerification==1)
    {

     
      setSteps(['Mobile verification']);
    }
    else if(userAccess.enableParentalVerification==1 && userAccess.enableMobileVerification==0)
    {
     
      setSteps(['Parental Consent']);
    }
    else 
    {
     
      setSteps(['Mobile verification', 'Parental Consent']);
    }


     //CHECK IF MOBILE VERIFICATION ENABLE OR NOT FOR CONDITION
     var checkMobilestatus=(userAccess.enableMobileVerification==1)? true:false;
    //PARENT ACCPECT AND PROFILE UNLOCK THE SHOW UNLOCK POPUP
    // /alert(acountlock,"==>",newMasterData[0].status,"==>",newMasterData[0].showPopup);
    if(newData.skipMobileVerification === false && newData.userID.isParent === true && newMasterData[0].status==1 && newMasterData[0].showPopup==1 && getInterestsData.length>0)
    {
     
      setOpenVerification(true);
      setSeventhscreen(true);
      setShowskipbutton(false);
      setFirstscreen(false);
      setFourthscreen(false);
      setSixthscreen(false);
      setFifthscreen(false);
      setSteps(['']);
      setParentstatus(1);
      setActiveStep(1);
      setSteps(['']);

    }
    //PAREN DECLINE PROFILE LOCKED THE SHOW DECLINE POPUP
    else if(newMasterData[0].status==3 && newMasterData[0].showPopup==3 && getInterestsData.length>0)
    {
      if(userAccess.enableParentalVerification==1)
      {
        setShowskipbutton(false);
        setSecondscreen(false);
        setFirstscreen(false);
        setFourthscreen(false);
        setFifthscreen(false);
        setSixthscreen(false);
        setSeventhscreen(false);
        setParentstatus(3);
        setEightscreen(true);
        setOpenVerification(true);
        setSteps(['']);
        setSettingmessage('')
        setPopupTopMsg('');
        setPopupSecondTopMsg('')
        //setSettingunlockmessage('');
      }
        
    }

    


    setParentapprovestatus(newData.userID.status)//SET PARENT APPROVE STATUS
    setMobile(newData.mobile_no);//SET DEFAULT MOBILE NUMBER
    setOldmobile(newData.mobile_no); //MOBILE NUMBER STORED BRFORE OTP VERIFY FOR GOTBACK BUTTON PURPOSE
    setCountryCode(newData.mobileCountrycode)
    setEmail(newData.parent_email);
    setParentmobile(newData.parent_mobile);
    setParentname(newData.parent_name);

    setParentcountryCode((newData.parentmobileCountrycode)?newData.parentmobileCountrycode:'91');

    let isMobileVerify = newData.isMobileVerified;
    let isParentVerify = newData.isParentVerified;
    let isparentRequestSent = newData.isparentRequestSent;


    //IF USER LOGIN FIRST TIME THE WE OPEN THE POPUP FORCEFULLY
    if (localStorage.getItem("loginFirstTime") === 'true') {
      
      if(userAccess.enableMobileVerification==1 && isMobileVerify==false && getInterestsData.length>0)
      {
       
        setOpenVerification(true);
      }
      else if(newData.userID.isParent === true && userAccess.enableParentalVerification==1 && isParentVerify==false && getInterestsData.length>0)
      {
      
        setOpenVerification(true);
      }
      
    }

    setMobileverification(newData.isMobileVerified);
    setParentverification(newData.isParentVerified);
    setParentrequestsent(newData.isparentRequestSent);

    //IF USER UNDER 18 AND MOBILE VERIFICATION DONE THEN SET THE ACTIVE STEP
    if (newData.userID.isParent == true) {
      setActiveStep((isMobileVerify === true) ? 1 : 0);
    }


    //SET THE PARENT SCREEN IF MOBILE VERIFIED
    if (isMobileVerify === checkMobilestatus && isParentVerify === false && newData.userID.isParent === true) {
        if(userAccess.enableParentalVerification==1)
        {
         
            setFourthscreen(true)
            setFirstscreen(false)
            setSixthscreen(false);
            setShowskipbutton(true);
        }
      }
       //SET PARENT REQUEST SENT BUT NITHER APPORVE NOR DECLINE
      if (isparentRequestSent==true && newData.userID.status ==2) {
        
          setParentrequestsent(true)
      
      }
      
      
    

    //IF USER ABOVE 18 HIDE THE PARENT SCREEN
    if (newData.userID.isParent == false)// SHOW/HIDE THE PARENTAL CONSENT
    {
      if(userAccess.enableMobileVerification==1)
      {
      setShowparentalconsent(false);
      setSteps(['Mobile verification']);
      }

    }
    //IF MOBILE VERIFICATION DONE AND USER ABOVE 18 AND PARENT EMAIL SENT
    if (newData.userID.isParent == true && isMobileVerify === checkMobilestatus) {
     
      if(userAccess.enableParentalVerification==1)
      {
        //IF REQUEST SEND TO VERIFY BUT AWAITIN FOR APPROVAL THEN
        if (isparentRequestSent == true && newData.userID.status != 1 &&  newData.userID.status != 3) {
          setFifthscreen(true);
          setFourthscreen(false);
          setFirstscreen(false);
          setSixthscreen(false);
          setShowskipbutton(false);
          setShowPendingicon(true);

        }
      }
    }
    //IF MOBILE VERIFICATION NOT DONE AND USER ABOVE 18 AND PARENT EMAIL SENT AND APPROVED
    if(userAccess.enableMobileVerification==1)
    {
      if(userAccess.enableParentalVerification==1)
      {
      if (newData.userID.isParent == true  && isParentVerify==true && isMobileVerify === false &&   newData.userID.status != 2 &&  newData.userID.status != 4) {
        setShowparentalconsent(false);
        setSteps(['Mobile verification']);
        
      }
      }
      //IF PAREWNT VERIFICATION DISBALE AD MOBILE VERIFICATIN NOT DONE YET THEN SET SCREEN
      else if(userAccess.enableParentalVerification==0 && isMobileVerify==false)
      {
       
        setShowparentalconsent(false);
        setSteps(['Mobile verification']);
      }
    }
   
    //WE HAVE SET THE DEFAULT STATE HERE AFTER USER LAUNCH
    const setdata = {
      mobileVerified: isMobileVerify,
      parentVerified: isParentVerify,
      isparentRequestSent: isparentRequestSent,
      
    }
    dispatch(userActions.verificationcheck(setdata));

   

    //CHANGE THE SETTING MESSAGE AS PER VERIFICATION
    //IF MOBILE NOT VERIFIED
    if (isMobileVerify == false) {
     
      if(userAccess.enableMobileVerification==1)
    {
      setSettingmessage("Please do your mobile verifcation.");
      //IF MOBILE NOT  VERIFIED AND USER UNDER 18 AND PARENT CONSENT NOT SEND
      if(newData.userID.isParent == true && isParentVerify == false && userAccess.enableParentalVerification==1)
      {
       
        //alert("1");
        setSettingmessage("Mobile verifcation and parental consent is pending -");
        ///setSettingunlockmessage("you must verify your mobile number and get parental consent.");
        setPopupTopMsg('Mobile verification & Parental consent is pending...');
        setPopupSecondTopMsg("If you don't verify your mobile number and receive parental consent with 72 hours,");
      }
       //IF MOBILE NOT  VERIFIED AND USER UNDER 18 AND PARENT CONSENT SENT BUT NOT APPROVE YET
      else if(userAccess.enableParentalVerification==1 && newData.userID.isParent == true && isParentVerify == true && (newData.userID.status == 2 || newData.userID.status == 4))
      {
        

        setSettingmessage("Mobile verifcation and parental consent is pending -");
        //setSettingunlockmessage("you must verify your mobile number and get parental consent.");
        setPopupTopMsg('Mobile verification & Parental consent is pending...');
        setPopupSecondTopMsg("If you don't verify your mobile number and receive parental consent with 72 hours,");
      }
      else 
      {
       
        setPopupTopMsg('Mobile verification is pending...');
        setSettingmessage("Mobile verification is pending -");
       /// setSettingunlockmessage("you must verify your mobile number.");
        setPopupSecondTopMsg("If you don't verify your mobile number and receive parental consent within 72 hours,");
      }
    }
    }

    if(userAccess.enableParentalVerification==1)
    {
   //IF MOBILE VERIFIED AND PARENT CONSENT NOT SEND YET
   
     if (isMobileVerify == checkMobilestatus && newData.userID.isParent == true && (isparentRequestSent == false || isparentRequestSent==null)) {
     
      
      //(" you must receive your parental consent.");
      setSettingmessage("Parental consent is pending -")
      setPopupTopMsg("Parental consent is pending...");
      setPopupSecondTopMsg("If you don't receive consent from your parent / guardian within 72 hours,");
    
    }
    //IF MOBILE VERIFIED AND PARENT CONSENT  SENT BUT STILL NOT APPROVE OR ACCOUNT LOCK THEN
    else if (isMobileVerify == checkMobilestatus && isparentRequestSent == true && (newData.userID.status == 2 || newData.userID.status == 4)) {
      
    
      setSettingmessage("Parent varification is pending -")
      setPopupTopMsg("Parental consent is pending...");
      setPopupSecondTopMsg("If we don't receive consent from your parent / guardian within 72 hours,");
      
     // setSettingunlockmessage("we must receive consent from your parent / guardian,");
    }
    //IF MOBILE VERIFIED AND PARENT CONSENT  SENT BUT STILL NOT APPROVE
    else if (isMobileVerify == checkMobilestatus && isparentRequestSent == true && newData.userID.status == 0) {
      
      setSettingmessage("Parent varification is pending -")
      setPopupTopMsg("Parental consent is pending...");
      setPopupSecondTopMsg("If we don't receive consent from your parent / guardian within 72 hours,");
      //setSettingunlockmessage(" we must receive consent from your parent / guardian");
     
      
      
    }
    //IF MOBILE VERIFIED AND PARENT CONSENT  SENT BUT ITS DECLINED
    else if (isMobileVerify == checkMobilestatus && isparentRequestSent == true && newData.userID.status == 3) {
     
     // alert("2"); 
      setSettingmessage('')
      setPopupTopMsg('');
      setPopupSecondTopMsg('')
     
    }
    else {
      //alert("3");
     // setSettingmessage('');
    }
  }

    }

    
  }
  setTimeout(() => {
    initialFun()   
  }, 5000);
  
  }, []);

  
  //IF PROFILE UNLOCK AND USER CLICKED ON GO TO MYSPHERE BUTTON
  const unlockGoto= async()=>
  {
    setOpenVerification(false);
   
    const userID = localStorage.getItem('userID'); //GET MASTER userID FROM localstorage 
    //const userMasterData = await API.graphql(graphqlOperation(queries.listUserMasters, { filter: { id: { eq: userID } }, limit: 10000 }));
    const userMasterData=await fetchItemsNextToken({query:queries.listUserMasters,variables:{ filter: { id: { eq: userID } }, limit: 10000 }})
    const items = userMasterData;
    const newMasterData = items.filter(item => item._deleted !== true);

    const userMasterDetailsData = { 'id': userID, 'showPopup': 0, '_version': newMasterData[0]._version };
    let userMasterupdate = await API.graphql(graphqlOperation(updateUserMaster, { input: userMasterDetailsData }));
  }
  //ON SETTING BUTTON OPEN THE POPUP
  const handleClickOpenVerification = () => {
    setOpenVerification(true);
  };
  //ON SKIP BUTTON CLOSED THE POPUP
  const handleCloseVerification = (event, reason) => {
   // console.log(reason);
    if (reason && reason == "backdropClick") {
      setOpenVerification(true);
    }
    else {
      setOpenVerification(false);
      localStorage.removeItem("loginFirstTime");
    }

  };
  //USER LOGOUT FUNCTION
  const handleLogout=()=>
  {
    dispatch(userActions.logout());
    navigate(process.env.PUBLIC_URL+'/signin');
  }

  //GOTO MYSHERE BUTTON CLLICK
  const handleGotomyshpere = () => {
    setOpenVerification(false);
    setMobileverification(true);
    localStorage.removeItem("loginFirstTime");
    setSettingmessage("Parent varification is pending -")
  }

  //TOST MESSGE CLICK EVENT
  const handleClickTost = () => { setOpenTost(true); };
  const handleCloseTost = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenTost(false);
  };

  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set());

  const isStepOptional = (step) => {
    return step === 1;
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  // ON NEXT BUTTON AFTER MOBILE APPROVE WILL SHOW THE PARENT CONSTENT SCREEN   
  const handleNext = () => {
    setPopupTopMsg("Parental consent is pending...");
    if(parentrequestsent==true)
    {
      
      setPopupSecondTopMsg("If we don't received parental permission within 72 hours,");
      setSettingmessage("Parental consent is pending -")
      setFifthscreen(true);
      setFourthscreen(false);
      setSixthscreen(false);
      setShowPendingicon(true);
    }
    else
    {
      
      setPopupSecondTopMsg("If you don't received parental permission within 72 hours,");
      //setSettingunlockmessage(" you must receive your parental consent.");
      setSettingmessage("Parental consent is pending -")
      setFourthscreen(true);
      setSixthscreen(false);
    }
    
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSkip = () => {
    if (!isStepOptional(activeStep)) {
      // You probably want to guard against something like this,
      // it should never occur unless someone's actively trying to break something.
      throw new Error("You can't skip a step that isn't optional.");
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped((prevSkipped) => {
      const newSkipped = new Set(prevSkipped.values());
      newSkipped.add(activeStep);
      return newSkipped;
    });
  };

  //SET MOBILE CHANGE SCREEN IF CLICK ON BACK TO SEND OTP
  const backToSendotp = () => {
    setSecondscreen(false);
    setFirstscreen(true);
    setMobile(oldmobile);
  }
  const handleReset = () => {
    setActiveStep(0);
  };

  const [age, setAge] = React.useState('');


  //SET USER COUNTRYCOIDE VALUE ON SELECT
  const handleChangeCountryCode = (event) => {
    setCountryCode(event.target.value);
  };
  const handleparentChangeCountryCode = (event) => {
    setParentcountryCode(event.target.value);
  };

  //ENABLE EDIT MOBILE IF EDIT ICON CLICKED
  const ediMobilenumber = () => {
    setMobiledis(false);
  }
  //RESEND MOBILE OTP FUNCTION
  const resend_mobile_otp = () => {
    setSeconds_mobile(60)
    setmobileSeconds(false)
    const userID = localStorage.getItem('userID'); 
    dispatch(userActions.sendOTP(userID, mobile,countryCode));
  }
  //SEND MOBILE OTP FUNCTION
  const send_mobile_otp = () => {
    setSeconds_mobile(60)
    setShowotp(true);
    setmobileSeconds(false)
    setSecondscreen(true);
    setFirstscreen(false);
    const userID = localStorage.getItem('userID'); 
    dispatch(userActions.sendOTP(userID, mobile,countryCode));
  }
  //VERIFY MOBILE OTP FUNCTION
  const verifyMobileOtp = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    if (data.get('mobileOTP') == "") {
      setOtpError("Please Enter OTP");

    }
    else if (validator.isInt(data.get('mobileOTP')) && validator.isLength(data.get('mobileOTP'), { min: 6, max: 6 })) {
      var raw = {
        "email": localStorage.getItem("email"),
        "otp_email": '',
        "otp_mobile": data.get('mobileOTP'),
        "mobile_no": mobile,
        "countryCode": countryCode,

      };
      dispatch(userActions.verifyOtp(raw));
    }
    else {
      setOtpError("Please enter a valid OTP");
    }
  }
  // SHOW PARENT PAGE IF ANYONE CLICK ON EDIT PARENT LINK
  const editParentdetails = () => {

    setShowskipbutton(true);
    setFourthscreen(true);
    setFifthscreen(false);
    setPopupSecondTopMsg("If you don't receive consent from your parent / guardian within 72 hours,");
   // setSettingunlockmessage(" you must receive your parental consent.");
  }

  //IF  PARENT DETAILS SENT THEN WE SHOW THE SUCCESS SCREENT
  useEffect(() => {
    if (authenticationState.showParentalSuccessScreen === true) {
      setFourthscreen(false);
      setFifthscreen(true);
      setPopupSecondTopMsg("If we don't receive consent from your parent / guardian within 72 hours,");
      setShowPendingicon(true);
    }
  }, [authenticationState.showParentalSuccessScreen]);

  // AFTER SUCCESS MOBILE VERIFICATION WE CHANGE THE STATE AND DISPLAY THANKS PAGE
  useEffect(() => {
    if (authenticationState.mobileVerified === true) {
     
      setSixthscreen(true);
      setSecondscreen(false);
      setActiveStep(1);

      if (!showparentalconsent) {

        setShowskipbutton(false);
        setShowlogoutbutton(false);
      }
      else if (showparentalconsent && parentverification == true) {

        setShowskipbutton(false);
      }
      const userrolenewData= getUseraccess(localStorage.getItem('userID'));
         userrolenewData.then(async (rolenewData)=>{
          localStorage.setItem("useAccessRole", JSON.stringify(rolenewData));
            //userAccessRoleContext.dispatch({type:'userAccessRole', payload: rolenewData});
         });
    

    }
  }, [authenticationState.mobileVerified]);

  //DISPLAY THE SUCCESSFULY TOST MESSGE IF MESSAGE STATE CHANGED
  useEffect(() => {
    if (authenticationState.openTost === true) {
      
      setOpenTost(authenticationState.openTost);
      setTost_msg(authenticationState.tostMsg);
      
      setTimeout(() => {
        
      dispatch(userActions.setTostMessage(false,'')) // CHANGE THE MESSAGE STATE
       
      }, 3000);
    }
  }, [authenticationState.openTost]);

  //SET OTP ALERT MESSAGE 
  useEffect(() => {
    if (alertState.type === "error") {
      setOtpError(alertState.message);
    }
  }, [alertState.message]);

  //START THE TIMER IF OTP SEND OR RESEND
  useEffect(() => {
    var timer2;
    if (seconds_mobile > 0) {
      timer2 = setTimeout(() => setSeconds_mobile(seconds_mobile - 1), 1000);
      setmobileSeconds(false)
    } else {
      clearTimeout(timer2);
      setSeconds_mobile('');
      setmobileSeconds(true)

    }
    return () => {
      clearTimeout(timer2);
    };
  }, [setSeconds_mobile, seconds_mobile]);


  //VALIDATE THE PARENT SUBMIT FORM
  const formValidate = (data) => {
    let nameError = "";
    let emailError = "";
    let mobileError = "";
    let gardianCheckError = "";

    const regMatchFirst = /^[a-zA-Z ]*$/.test(data.get('name'));
    const regMatchLast = /^[a-zA-Z ]*$/.test(data.get('lastName'));
    let regEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (data.get('name') == '') {
      nameError = "Please enter your name";
    }
    else if (!regMatchFirst) {
      nameError = "Please enter a valid name";
    }
    else {
      nameError = "";
    }
    if (data.get('email') == '') {
      emailError = "Please enter a valid email address";
    }
    else if (!regEmail.test(data.get('email'))) {
      emailError = "Please enter a valid email address";
    }
    else if (data.get('email') == userEmail) {
      emailError = "Your email address cannot be same as that of your parent/guardian";
    }
    else {
      emailError = "";
    }

    if (data.get('parentmobile') == '') {
      mobileError = "Please enter a mobile number";
    }
    else if (!/^[0-9\b]+$/.test(data.get('parentmobile')) || data.get('parentmobile').length < 8) {
      mobileError = "Please enter a valid mobile number";
    }
    else if (data.get('parentmobile') == mobile) {
      mobileError = "Your mobile cannot be same as that of your parent/guardian";
    }
    else {
      mobileError = "";
    }

    if (gardianCheck === false) {
      gardianCheckError = "Please confirm that the details provided are of your parent/guardian";
    }
    else {
      gardianCheckError = "";
    }


    if (nameError || emailError || mobileError || gardianCheckError) {
      setNameError(nameError);
      setEmailError(emailError);
      setMobileError(mobileError);
      setGardianCheckError(gardianCheckError);
      return false;
    }
    else {
      setNameError('');
      setEmailError('');
      setMobileError('');
      setGardianCheckError('');
    }

    return true;
  }

  //RESEND THE PARENT EMAIL FUNCTION
  const resendParentemail = () => {

    dispatch(userActions.resendParentEmail())
  }
  // ADD PARENT DETAILS AND SEND EMAIL FOR APPROVE
  const handleSubmit = (event) => {

    event.preventDefault();

    const data = new FormData(event.currentTarget);
    let isValid = formValidate(data);

    if (isValid) {

      try {
        var sendData = {
          parentName: data.get('name'),
          parentEmail: data.get('email'),
          parentMobile: data.get('parentmobile'),
          parentMobile: data.get('parentmobile'),
          parentCountryCode:parentcountryCode,

        }
        dispatch(userActions.parentalRegister(sendData))
        setParentEmail(data.get('email'));
        setShowskipbutton(false);
        setNextclick(false);
        setParentrequestsent(true);
        //setSettingunlockmessage("we must receive consent from your parent / guardian,");


      } catch (error) {
        console.log('error signing up:', error);

      }
    }
  };

  return (
    <>
      <Stack spacing={2} sx={{ width: '100%' }}>
        <Snackbar open={openTost} autoHideDuration={6000} onClose={handleCloseTost}>
          <Alert onClose={handleCloseTost} severity="success" sx={{ width: '100%' }}>
            {Tost_msg}
          </Alert>
        </Snackbar>

      </Stack>
      {/* DISPLAY THE ALERT MESSAGE IF VERIFICATION PENDING */}
      {props.isFeedPage==true &&
         <>
       
      {(mobileverification == false || (showparentalconsent && parentapprovestatus == 2)) &&
        <>
         
          {settingmessage &&
            <div className='skip_verification_msg'>
              <div className='custom_container'>
                <div className='skip_verification_msg_inner'><div><Warning className='notification' /> {settingmessage} <Link href="#" onClick={handleClickOpenVerification}>Verify Now</Link></div>
                </div>
              </div>
            </div>
          }
        </>
      }
      </>
      }
      {/* MOBILE VERIFICATION SCREN START HERE */}
      <div>
        <Dialog className="mn_verification_dialog" fullScreen={fullScreen} open={openVerification} onClose={handleCloseVerification} aria-labelledby="responsive-dialog-title" disableEscapeKeyDown={true} disablebackdropclick={"false"}>
          <DialogContent>
            <div className={(parrentatatus!=3 && parrentatatus!=1)? 'mn_verification_dialog_headings':''}>
            {/* <div className='mn_verification_dialog_headings'> */}
              
                            
                  {showparentalconsent && popupTopMsg && 
                    <>
                     <img src={mebileverification1} width="50px" />
                    <Typography variant="h6" component="h6">{popupTopMsg}</Typography>
                    {/* <Typography variant="p" component="p">{popupSecondTopMsg}<br></br> your account will be locked.</Typography> */}
            
                    </>
                  }
                   
                  
                  {/* IF ACCOUNT NOT LOCKED THE CHANGE THE MESSAGE */}
                  {!showparentalconsent &&
                    <>
                    <img src={mebileverification1} width="50px" />
                      <Typography variant="h6" component="h6">Mobile verification is pending...</Typography>
                      {/* <Typography variant="p" component="p">If you don't verify your mobile number within 72 hours,<br></br> your account will be locked.</Typography> */}
                    </>
                  }
               
              
              {/* SET SKIPED BUTTON AS PER CONDITIONS */}
              {showskipbutton &&
                <Button onClick={handleCloseVerification} >Skip for now <ChevronRight /></Button>
              }
              {Showlogoutbutton &&
                <Button onClick={handleLogout} >Logout <ChevronRight /></Button>
              }
          </div>
          
            <Box sx={{ width: '100%' }} className={parrentatatus!=3? 'mn_verification_content':''} >
            {parrentatatus==0 &&
              <Stepper activeStep={activeStep} >
                {steps.map((label, index) => {
                  const stepProps = {};
                  const labelProps = {};
                  
                  if (isStepSkipped(index)) {
                    stepProps.completed = false;
                  }
                  return (
                    <Step key={label} className={(label=='Parental Consent' && showPendingicon==true)?"ParentPending":""} {...stepProps}>
                      <StepLabel {...labelProps}>{label}</StepLabel>
                    </Step>
                  );
                })}
              </Stepper>
            }
              <>
                <React.Fragment>
                  {/* SET THE PARENT SCREEN */}
                  {fourthscreen &&
                    <Grid className="mn_verification_screen4">
                      <Box component="form" noValidate onSubmit={handleSubmit}>
                        <p className='patentslnote'><svg viewBox="0 0 24 24" width="20" height="20" stroke="#6F6F8B" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" className="css-i6dzq1"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg> Please provide your parent / guardian's details since you are under the age of 18</p>
                        <FormControl fullWidth className='formControl'>
                          <label>Parent's / Guardian's name*</label>
                          <TextField
                            autoComplete="none"
                            name="name"
                            required
                            fullWidth
                            id="name"
                            autoFocus
                            helperText={nameError}
                            value={parentname}
                            error={!!nameError}
                            onChange={(event) => setParentname(event.target.value)}
                          />
                        </FormControl>
                        <Grid container columnSpacing={{ xs: 0, sm: 2, md: 2 }}>
                          <Grid item md={6}>
                            <FormControl fullWidth className='formControl'>
                              <label>Parent's / Guardian's email*</label>
                              <TextField
                                autoComplete='off'
                                required
                                fullWidth
                                id="email"
                                name="email"
                                type="email"
                                // autoComplete="email"
                                helperText={emailError}
                                error={!!emailError}
                                value={email}
                                onChange={(event) => setEmail(event.target.value)}
                              />
                            </FormControl>
                          </Grid>
                          <Grid item md={6}>
                            <FormControl fullWidth className='formControl'>
                              <label>Parent's / Guardian's mobile*</label>
                              <div className='mobile_box_verification_main'>
                                <div className="mobile_box_verification">
                                  <Select className='mobile_code'
                                    autoComplete="none"
                                    labelId="demo-simple-select-autowidth-label"
                                    id="demo-simple-select-autowidth"
                                    name={'countryCode'}
                                    value={parentcountryCode}
                                    onChange={handleparentChangeCountryCode}
                                    autoWidth
                                  >

                                    {countryData.map((item) =>
                                      <MenuItem key={item.phone_code} value={item.phone_code}>+{item.phone_code}</MenuItem>
                                    )}
                                  </Select>
                                  <TextField className='mobile_code_number' autoComplete="none"
                                    required
                                    fullWidth
                                    id="mobile"
                                    name="parentmobile"
                                    type="tel"
                                    helperText={mobileError}
                                    error={!!mobileError}
                                    InputProps={{

                                      inputMode: 'numeric', pattern: '[0-9]*'
                                    }}
                                    value={parentmobile}
                                    onChange={(event) => setParentmobile(event.target.value)} />
                                </div>
                              </div>
                            </FormControl>
                          </Grid>
                        </Grid>
                        <Grid item md={12}>
                          <FormControl fullWidth className='formControl checkbox_control'>
                            <FormControlLabel control={<Checkbox checked={gardianCheck} error={!!gardianCheckError} onChange={() => setGardianCheck(!gardianCheck)} />} label="I confirm that above details are of my Parent / Guardian" />
                            {!!gardianCheckError &&
                              <FormHelperText className="Mui-error">{gardianCheckError}</FormHelperText>
                            }
                          </FormControl>
                        </Grid>
                        <Grid item md={12} className='form_buttons'>
                          <Button className='default_btn' type='submit'>Verify parent details</Button>
                        </Grid>
                      </Box>
                    </Grid>
                  }
                  {/* SET PARENT THANKS PAGE  */}
                  {fifthscreen &&
                    <Grid className="mn_verification_screen5">
                      <Typography variant="h4" component="h4">Thank You! <br></br> <img src={awaiting_parental_consent} width="25px" />Awaiting parental consent...</Typography>
                      <Typography variant="p" component="p">Mail requesting Parental Consent has been sent to <strong>{parentemail} </strong> <br></br>If it is not received by your parent / guardian, please check the Spam folder.</Typography>
                      <div className='screen_action_btns'>
                        <Button onClick={editParentdetails}><Edit /> Edit details</Button>
                        <Button onClick={resendParentemail}><Sync /> Resend email</Button>
                      </div>
                     
                        <div className='screen_action_btns extra_btns'>
                          <Button className="default_btn" onClick={handleGotomyshpere}>Go to MySphere</Button>

                        </div>
                     
                    </Grid>

                  }
                   {/* AFTER UNLOCK PROFILE */}
                   {seventhscreen &&
                  <Grid className="mn_verification_screen6">
                        <img src={account_unlocked} width="78px"/>
                          <Typography variant="h4" component="h4">Your account has been unlocked</Typography>
                          <Typography variant="p" component="p">Congratulations! Your Mysphere account has been activated.</Typography>
                        <div className='screen_action_btns'>
                            <Button className="default_btn" onClick={unlockGoto}>Go to MySphere</Button>
                        </div>
                    </Grid>
                  }
                </React.Fragment>
                <React.Fragment>
                  {/* SET MOBILE APPROVE SCREEN */}
                  {firstscreen &&
                    <Grid className="mn_verification_screen1">
                      <FormControl fullWidth className='formControl'>
                        <label>Mobile number*</label>
                        <div className='mobile_box_verification_main'>
                          <div className="mobile_box_verification">
                            <Select className='mobile_code'
                              autoComplete="none"
                              labelId="demo-simple-select-autowidth-label"
                              id="demo-simple-select-autowidth"
                              name={'countryCode'}
                              value={countryCode}
                              disabled={mobiledis}
                              onChange={handleChangeCountryCode}
                              autoWidth
                            >
                              {countryData.map((item) =>
                                <MenuItem key={item.phone_code} value={item.phone_code}>+{item.phone_code}</MenuItem>
                              )}
                            </Select>
                            <TextField className='mobile_code_number'
                              autoComplete="none"
                              required
                              fullWidth
                              id="mobile"
                              name="mobile"
                              type="tel"
                              disabled={mobiledis}
                              InputProps={{
                                inputMode: 'numeric', pattern: '[0-9]*'
                              }}
                              value={mobile}
                              onChange={(event) => setMobile(event.target.value)}
                            />
                            <IconButton className="vedit_btn" type="submit" aria-label="search" onClick={ediMobilenumber}><Edit /></IconButton>
                          </div>
                          <Button className="default_btn" onClick={send_mobile_otp}>Send OTP</Button>
                        </div>
                      </FormControl>
                    </Grid>
                  }
                  {/* MOBILE OTP VERIFICATION SCREEN  */}
                  {secondscreen &&

                    <Grid className="mn_verification_screen2">
                      <Box component="form" noValidate onSubmit={verifyMobileOtp}>
                        <Typography variant="p" component="p">Enter the verification code sent to  {mobile}.<br></br>If you don't receive it, you can request to resend code after 1 min</Typography>
                        <FormControl fullWidth className='formControl'>
                         
                          <div className='mobile_box_verification_main'>
                          <div className="mobile_box_verification">
                            <div className="otp_verification_wrap_main">
                              <div className="otp_verification_wrap">
                                {/* <OtpForm onChange={handleOnChange} numberOfInputs={6} type="text"                              />
                                {otpError &&
                                  <p class="MuiFormHelperText-root Mui-error MuiFormHelperText-sizeMedium MuiFormHelperText-contained Mui-required css-v7esy" id="otp-helper-text">{otpError}</p>
                                } */}
                                
                                  <TextField
                                  required
                                  autoComplete="none"
                                  fullWidth
                                  id="mobileOTP"
                                  name="mobileOTP"
                                  type="text"
                                  // type="number"
                                  definitions={{
                                    '#': /[1-9]/,
                                  }}
                                  helperText={otpError}
                                  error={!!otpError}
                                  // placeholder="Type the code received on your email here"
                                  inputProps={{ maxLength : 6 }}
                                  className="otp_verification_input"
                                  />
                             
                              </div>

                              {secondsISmobile == false ? <span><img src={OTPTime} /><p><strong>{seconds_mobile}</strong> sec remaining</p></span>
                                : null}
                              {secondsISmobile == true ?
                                <span><Button onClick={resend_mobile_otp}><Sync /> Resend OTP</Button></span>
                                : null}
                            </div>
                          </div>
                        </div>
                          <div className='screen_action_btns'>
                            <Button className="default_btn_border" onClick={backToSendotp}>Go back</Button>
                            <Button type="submit" className='default_btn'>Verify now</Button>
                          </div>
                        </FormControl>
                      </Box>

                    </Grid>

                   
                  }
                  {/* MOBILE VERIFICATION SUCCESS SCREEN */}
                  {sixthscreen &&
                    <Grid className="mn_verification_screen3">
                      <img src={mobile_verified_successfully} width="41px" />
                      <Typography variant="p" component="p">Your mobile number has been verified successfully</Typography>
                      <div className='screen_action_btns'>

                        {showparentalconsent &&
                          <Button className="default_btn" onClick={handleNext}>Next <ChevronRight /></Button>
                        }
                        {!showparentalconsent &&
                          <Button className="default_btn" onClick={handleGotomyshpere}>Go to MySphere <ChevronRight /></Button>
                        }
                      </div>
                    </Grid>}
                    {eightscreen &&
                    <Grid className="mn_verification_decline">
                    <img src={ParentalDecline} />
                    <Typography variant="p" component="p">Sorry! your parental consent request has been declined</Typography>
                    <div className='screen_action_btns extra_btns'>
                        <Button className="default_btn gotoMysphere" onClick={handleLogout}>Logout</Button>
                    </div>
                </Grid>
                  }
                </React.Fragment>
              </>
            </Box>
          </DialogContent>
        </Dialog>
      </div>

      {/* Skipped  */}
    </>
  )
}

export default ConfirmationPopup;